import { render, staticRenderFns } from "./selfTest.vue?vue&type=template&id=78dcec59&scoped=true"
import script from "./selfTest.vue?vue&type=script&lang=js"
export * from "./selfTest.vue?vue&type=script&lang=js"
import style0 from "./selfTest.vue?vue&type=style&index=0&id=78dcec59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dcec59",
  null
  
)

export default component.exports